import React from "react";
import { useNavigate } from "react-router-dom";
import { Result, Button, Space } from "antd";
import { CheckCircleOutlined, HomeOutlined, ShoppingOutlined } from "@ant-design/icons";
import "./payment-success.css";

const PaymentSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="payment-success-container">
      <Result
        status="success"
        icon={<CheckCircleOutlined style={{ color: "#52c41a" }} />}
        title="Оплата успешно выполнена"
        subTitle="Ваш платеж был успешно обработан. Спасибо за покупку!"
        extra={[
          <Space key="actions" size="middle">
            <Button
              type="primary"
              icon={<ShoppingOutlined />}
              onClick={() => navigate("/sales/active")}
            >
              Мои покупки
            </Button>
            <Button
              icon={<HomeOutlined />}
              onClick={() => navigate("/")}
            >
              На главную
            </Button>
          </Space>,
        ]}
      />
    </div>
  );
};

export default PaymentSuccess;
